<template >
  <v-card class="mx-auto theme-bg">
    <div>
      <label>
        <gmap-autocomplete @place_changed="setPlace" style="width: 50%;border: 1px solid #ccc;height: 35px;margin: 10px 16px;"></gmap-autocomplete>
        <v-btn @click="addMarker" color="primary">Find</v-btn>
      </label>
      <br />
    </div>
    Google map : {{this.mapCoordinates}}
    <GmapMap
      :center="{lat: this.coords.lat,lng:this.coords.lng }" :zoom="this.zoom" zoomControl: true  map-type-id="terrain"
      style="width: 100%; height: 42vh"
      ref="mapRef"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
      ></gmap-marker>
    </GmapMap>
  </v-card>
</template>


<script>

import {gmapApi} from 'vue2-google-maps';
export default {
  name: "Map",
  components: {
  },
  data: () => ({
    mapGoogle: `Your Map`,
    locationDetails: {},
    coords: {
      lat: 0,
      lng: 0,
    },
    zoom: 15,
    map: null,
    google:gmapApi,
    markers: [],
    places: [],
    currentPlace: null,
    directionsDisplay:null

  }),
  methods: {
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        console.log(this.currentPlace.geometry.location);
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        // this.coords = marker;
        this.markers.push({ position: marker });
        this.zoom = 20;
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
        this.getRoute();
      }
    },
    getRoute: function (destination) {

      this.directionsService = new window.google.maps.DirectionsService()
      this.directionsDisplay = new window.google.maps.DirectionsRenderer()
      this.directionsDisplay.setMap(this.$refs.mapRef.$mapObject)
      var vm = this
      vm.directionsService.route({
        origin: this.coords,
        destination:  destination,
        travelMode: 'DRIVING'
      }, function (response, status) {
        if (status === 'OK') {
          vm.directionsDisplay.setDirections(response)
        } else {
          console.log('Directions request failed due to ' + status)
        }
      })
    }
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => (this.map = map));
        Event.$on("locate", (data) => {
          data= data.msg.slice(7)
          if(!data) return;
        this.getRoute(data);
        // return;
    });
  },
  created() {
    // this.getWeather();
    this.$getLocation({}).then((coords) => {
      this.coords = coords;
      this.markers.push({ position: coords });
      console.log(this.coords);
    });
  },
  computed: {
    mapCoordinates() {
      if (!this.map) {
        return {
          lat: 0,
          lng: 0,
        };
      }

      return {
        lat: this.map.getCenter().lat(),
        lng: this.map.getCenter().lng(),
      };
    },
  },
};
</script>

<style scoped>
</style>
